var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import loadable from '@loadable/component';
import { AlternateHrefLangLink, PropertyMeta, NamedMeta, PaginationAttribute } from 'bernie-http';
import { checkValue } from 'components/functions';
import { getDomain, getDomainFromUmbracoLocale } from 'src/stores/helpers/data-maps';
import { generateSnippet } from 'stores/helpers/snippet-helper';
import { formatCMSImageNodeToURL } from 'stores/helpers/storeHelpers';
var GoGuidesController = /** @class */function () {
  function GoGuidesController() {
    this.pageId = 'GoGuides';
    this.path = '/go';
    this.routeName = 'goguides';
    this.routeData = {
      rfrrNamespace: 'MESO3.GOGUIDES',
      pageName: 'page.goguides'
    };
    /**
     * Components may be referred to directly
     *   `public component = DestinationHubPage;`
     *
     * Or, the preferred option is to create a code split point that will generate a new bundle.
     *   Use webpack's magic comments `webpackChunkName: "INSERT_FRIENDLY_NAME_HERE"`
     *   This will give it a friendly name for the name of the file.
     */
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "goguides";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import( /* webpackChunkName: "goguides" */'../views/page');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("../views/page");
        }
        return eval('require.resolve')("../views/page");
      }
    });
    this.exact = false;
  }
  GoGuidesController.prototype.fetch = function (options) {
    return __awaiter(this, void 0, Promise, function () {
      var stores, _a, context, query, path, response, contextStore, goGuidesStore, viewModelResponse, alternateUrls, canonicalPath;
      return __generator(this, function (_b) {
        stores = options.stores, _a = options.request, context = _a.context, query = _a.query, path = _a.path, response = options.response;
        contextStore = stores.get("context");
        goGuidesStore = stores.get('goGuidesStore');
        viewModelResponse = JSON.parse(JSON.stringify(contextStore.viewModelResponse));
        if (checkValue(viewModelResponse)) {
          goGuidesStore.setupStore(viewModelResponse, context.locale, contextStore.contentLocale);
          alternateUrls = viewModelResponse.alternateUrls;
          if (checkValue(alternateUrls) && checkValue(alternateUrls[contextStore.cmsLocale])) {
            canonicalPath = alternateUrls[contextStore.cmsLocale];
            if (canonicalPath !== '/home' && canonicalPath !== path) {
              goGuidesStore.setCanonicalUrlToReplace('/go' + canonicalPath);
            }
          }
        } else {
          console.log("ggcontent: 404 from capsapi: context: ", JSON.stringify(function (_a) {
            var locale = _a.locale,
              langId = _a.langId,
              site = _a.site;
            return {
              locale: locale,
              langId: langId,
              site: site
            };
          }(context)));
          GoGuidesController.redirectResponse(response, '/404/?rfrr=goguides');
        }
        if (checkValue(query.format) && "json" == query.format) {
          goGuidesStore.setPageUrlData({
            contentTypeId: 98
          });
          return [2 /*return*/, Promise.resolve({})];
        }
        return [2 /*return*/, Promise.resolve({})];
      });
    });
  };
  GoGuidesController.prototype.fetchPageData = function (options) {
    return __awaiter(this, void 0, Promise, function () {
      var query, context, request, path, locale, domain, umbracoLocale, title, description, image, seo, viewModelResponse, pageType_1, siteName, tmpDescription, tmpImage, alternateUrls, metaTitle, ogMetaTitle, ogMetaDescription, ogMetaType, ogMetaImage, canonicalUrl, keys, xDefaultUrl, prefetchPreconnect, mergeMetaElements;
      return __generator(this, function (_a) {
        query = options.query, context = options.context, request = options.request;
        path = request.path;
        locale = checkValue(query.lang) && query.lang !== '' ? query.lang : context === null || context === void 0 ? void 0 : context.locale;
        domain = getDomain(locale);
        if (domain === undefined) {
          domain = getDomain('en_GB');
        }
        umbracoLocale = domain.umbracoLocale;
        seo = {};
        viewModelResponse = context.viewModelResponse;
        if (checkValue(viewModelResponse)) {
          pageType_1 = viewModelResponse.contentType;
          siteName = locale === 'fr_FR' || locale === 'fr_CA' ? ': Guides Go!' : '- Go Guides';
          tmpDescription = void 0;
          tmpImage = void 0;
          if (checkValue(viewModelResponse.introText) && checkValue(viewModelResponse.introText.markup)) {
            tmpDescription = generateSnippet(viewModelResponse.introText.markup, 60, context.contentLocale);
          }
          if (checkValue(viewModelResponse.image)) {
            tmpImage = formatCMSImageNodeToURL(viewModelResponse.image, true);
          }
          title = pageType_1 === 'goGuidesHome' ? "".concat(viewModelResponse.h1, " - ").concat(viewModelResponse.h2) : "".concat(viewModelResponse.h1, " - ").concat(viewModelResponse.h2, " ").concat(siteName);
          description = tmpDescription;
          image = tmpImage;
          alternateUrls = [];
          metaTitle = new NamedMeta('title', title);
          ogMetaTitle = new PropertyMeta('og:title', title);
          ogMetaDescription = new PropertyMeta('og:description', description);
          ogMetaType = new PropertyMeta('og:type', 'website');
          ogMetaImage = new PropertyMeta('og:image', image);
          canonicalUrl = "".concat(domain.cannoical).concat(path).replace(/\/$/, '');
          if (checkValue(viewModelResponse.alternateUrls)) {
            // in case of URL mismatch with the locale, use the locale url (home are all the same)
            if (pageType_1 !== 'goGuidesHome') {
              if (checkValue(viewModelResponse.alternateUrls[umbracoLocale])) {
                canonicalUrl = "".concat(domain.cannoical, "/go").concat(viewModelResponse.alternateUrls[umbracoLocale]);
              }
            }
            keys = Object.keys(viewModelResponse.alternateUrls);
            alternateUrls = keys.map(function (key) {
              var urlData = pageType_1 === 'goGuidesHome' ? '/go' : "/go".concat(viewModelResponse.alternateUrls[key]);
              var adjustedLocale = getDomainFromUmbracoLocale(key).locale.replace('_', '-');
              return new AlternateHrefLangLink(adjustedLocale, "".concat(getDomainFromUmbracoLocale(key).domain).concat(urlData));
            });
            // provide xDefault alternate URL only if available
            if (checkValue(viewModelResponse.alternateUrls[domain.xDefaultUmbracoLocale])) {
              xDefaultUrl = pageType_1 == 'goGuidesHome' ? "".concat(domain.xDefault, "/go") : "".concat(domain.xDefault, "/go").concat(viewModelResponse.alternateUrls[domain.xDefaultUmbracoLocale]);
              alternateUrls.push(new AlternateHrefLangLink('x-default', xDefaultUrl));
            }
          }
          prefetchPreconnect = [new PaginationAttribute('dns-prefetch', 'https://a.travel-assets.com'), new PaginationAttribute('dns-prefetch', 'https://b.travel-assets.com'), new PaginationAttribute('dns-prefetch', 'https://c.travel-assets.com'), new PaginationAttribute('dns-prefetch', 'https://images.trvl-media.com'), new PaginationAttribute('dns-prefetch', 'https://goguides.azureedge.net'), new PaginationAttribute('preconnect', 'https://a.travel-assets.com'), new PaginationAttribute('preconnect', 'https://b.travel-assets.com'), new PaginationAttribute('preconnect', 'https://c.travel-assets.com'), new PaginationAttribute('preconnect', 'https://images.trvl-media.com'), new PaginationAttribute('preconnect', 'https://goguides.azureedge.net')];
          mergeMetaElements = __spreadArray(__spreadArray([metaTitle, ogMetaTitle, ogMetaDescription, ogMetaType, ogMetaImage], __read(alternateUrls), false), __read(prefetchPreconnect), false);
          seo = {
            title: title,
            seo: {
              description: description,
              canonical: canonicalUrl,
              additionalMeta: mergeMetaElements,
              robots: ''
            }
          };
        }
        return [2 /*return*/, Promise.resolve(__assign({}, seo))];
      });
    });
  };
  GoGuidesController.redirectResponse = function (response, redirectUrl) {
    response.redirect(301, redirectUrl);
  };
  return GoGuidesController;
}();
export { GoGuidesController };